import FlowQuote from './FlowQuote';

export default FlowQuote;
